import React from 'react';
const evidences = [{
  title: 'De Piedras Blancas al Penal de Libertad',
  subtitle: 'Cómo el barrio y la noche de Montevideo forjaron al estratega.'
}, {
  title: 'La Universidad del Boliche',
  subtitle: 'El laboratorio donde Marset aprendió que el poder reside en la exclusividad, no en la violencia.'
}, {
  title: 'El Caos de Dubái',
  subtitle: 'La verdad detrás del Decreto 129/014 y cómo un pasaporte legal humilló a la diplomacia internacional.'
}, {
  title: 'Jaque al Rey',
  subtitle: 'El operativo de madrugada en Las Palmas, los vehículos blindados Nivel 7, las 16 aeronaves y el fin de la red.'
}, {
  title: 'El Pacto del Silencio',
  subtitle: 'Las conexiones encriptadas, el caso Pecci y lo que el expediente federal puede revelar sobre el Cono Sur.'
}];
export function EvidenceSection() {
  return <section className="w-full py-12 px-4 bg-black" data-id="element-30">
      <div className="max-w-4xl mx-auto" data-id="element-31">
        <h2 className="font-['Playfair_Display'] font-bold text-4xl md:text-5xl text-[#B8B8B8] mb-8 text-center" data-id="element-32">
          Dentro del libro
        </h2>

        <div className="space-y-4" data-id="element-33">
          {evidences.map((evidence, index) => <div key={index} className="group relative bg-zinc-950/50 border border-zinc-800/50 p-6 md:p-8 hover:border-[#C5A014]/50 transition-all duration-300" data-id="element-34">
              <div className="flex items-start gap-6" data-id="element-35">
                {/* Number */}
                <div className="flex-shrink-0" data-id="element-36">
                  <span className="font-['Playfair_Display'] font-bold text-5xl md:text-6xl text-[#C5A014] leading-none" data-id="element-37">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>

                {/* Content */}
                <div className="flex-1 pt-2" data-id="element-38">
                  <h3 className="font-['Playfair_Display'] font-bold text-2xl md:text-3xl text-zinc-200 mb-2" data-id="element-39">
                    {evidence.title}
                  </h3>
                  <p className="font-['Crimson_Text'] text-lg md:text-xl text-zinc-400 leading-relaxed" data-id="element-40">
                    {evidence.subtitle}
                  </p>
                </div>
              </div>

              {/* Decorative line */}
              <div className="absolute bottom-0 left-0 h-[1px] w-0 bg-[#C5A014] group-hover:w-full transition-all duration-500" data-id="element-41" />
            </div>)}
        </div>
      </div>
    </section>;
}